<template>
  <div class="activity">
      <ul class="activity-list">
        <li
          class="activity-item"
          v-for="(activity, index) in activityList"
          :key="index"
          @click="goArticleDeail(activity)">
          <img :src="activity.img" alt="">
          <div class="content-wrapper">
            <p class="title">{{ activity.title }}</p>
            <div class="activity-info">
              <span :class="['status', {'ready': activity.status === '即将开始', 'running': activity.status === '进行中'}]">{{ activity.status }}</span>
              <span class="date">活动时间：{{ activity.time }}</span>
            </div>
          </div>
        </li>
      </ul>
  </div>
</template>

<script>
export default {
  props: {},
  data () {
    return {
      activityList: [
        {
          title: '阿里云开发者社区联合阿里云计算平台事业部，共同出品了本期技术沙龙，现场不仅有阿里云专家分享外',
          status: '进行中',
          time: '2021-12-14 12:00 ~ 2021-12-16 18:00',
          id: 908,
          img: 'https://seopic.699pic.com/photo/50169/5465.jpg_wh1200.jpg'
        }, {
          title: '专为AI研发打造的DevCloud GPU开发机来了！',
          status: '即将开始',
          time: '2021-12-14 12:00 ~ 2021-12-16 18:00',
          id: 908,
          img: 'https://seopic.699pic.com/photo/50169/5465.jpg_wh1200.jpg'
        }, {
          title: '阿里云开发者社区联合阿里云计算平台事业部，共同出品了本期技术沙龙，现场不仅有阿里云专家分享外',
          status: '进行中',
          time: '2021-12-14 12:00 ~ 2021-12-16 18:00',
          id: 908,
          img: 'https://seopic.699pic.com/photo/50169/5465.jpg_wh1200.jpg'
        }, {
          title: '专为AI研发打造的DevCloud GPU开发机来了！',
          status: '已结束',
          time: '2021-12-14 12:00 ~ 2021-12-16 18:00',
          id: 908,
          img: 'https://seopic.699pic.com/photo/50169/5465.jpg_wh1200.jpg'
        }, {
          title: '阿里云开发者社区联合阿里云计算平台事业部，共同出品了本期技术沙龙，现场不仅有阿里云专家分享外',
          status: '即将开始',
          time: '2021-12-14 12:00 ~ 2021-12-16 18:00',
          id: 908,
          img: 'https://seopic.699pic.com/photo/50169/5465.jpg_wh1200.jpg'
        }, {
          title: '专为AI研发打造的DevCloud GPU开发机来了！',
          status: '已结束',
          time: '2021-12-14 12:00 ~ 2021-12-16 18:00',
          id: 908,
          img: 'https://seopic.699pic.com/photo/50169/5465.jpg_wh1200.jpg'
        }, {
          title: '阿里云开发者社区联合阿里云计算平台事业部，共同出品了本期技术沙龙，现场不仅有阿里云专家分享外',
          status: '即将开始',
          time: '2021-12-14 12:00 ~ 2021-12-16 18:00',
          id: 908,
          img: 'https://seopic.699pic.com/photo/50169/5465.jpg_wh1200.jpg'
        }, {
          title: '专为AI研发打造的DevCloud GPU开发机来了！',
          status: '进行中',
          time: '2021-12-14 12:00 ~ 2021-12-16 18:00',
          id: 908,
          img: 'https://seopic.699pic.com/photo/50169/5465.jpg_wh1200.jpg'
        }, {
          title: '阿里云开发者社区联合阿里云计算平台事业部，共同出品了本期技术沙龙，现场不仅有阿里云专家分享外',
          status: '即将开始',
          time: '2021-12-14 12:00 ~ 2021-12-16 18:00',
          id: 908,
          img: 'https://seopic.699pic.com/photo/50169/5465.jpg_wh1200.jpg'
        }, {
          title: '专为AI研发打造的DevCloud GPU开发机来了！',
          status: '已结束',
          time: '2021-12-14 12:00 ~ 2021-12-16 18:00',
          id: 908,
          img: 'https://seopic.699pic.com/photo/50169/5465.jpg_wh1200.jpg'
        }
      ]
    }
  },
  methods: {
    goArticleDeail (activity) {
        let routeData = this.$router.resolve({
            name: 'activityDetail',
            params: {
              wid: activity.id
            }
        })
        window.open(routeData.href, '_blank')
    },
  }
}
</script>

<style lang="scss" scoped>
  .activity {
    padding: 24px 23px 80px 24px;
    .activity-list {
      display: flex;
      align-items: flex-start;
      flex-wrap: wrap;
      width: 100%;
      .activity-item {
        width: 384px;
        height: 316px;
        display: flex;
        flex-direction: column;
        opacity: 1;
        margin: 0 15px 16px 0;
        border: 1px solid #dcdee5;
        cursor: pointer;
        img {
          height: 206px;
          width: 381px;
        }
        .content-wrapper {
          height: 110px;
          width: 100%;
          padding: 14px 14px 0;
          .title {
            font-weight: 700;
            color: #313238;
            line-height: 19px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            margin-bottom: 10px;
          }
          .activity-info {
            display: flex;
            align-items: center;
            font-size: 12px;
          }
          .status {
            width: 63px;
            height: 26px;
            line-height: 26px;
            text-align: center;
            border-radius: 2px;
            margin-right: 8px;
            color: #fff;
            background: #c4c6cc;
            &.running {
              background: #14a568;
            }
            &.ready {
              background: #efa93a;
            }
          }
          .data {
            color: #63656e;
            line-height: 16px;
            white-space: initial;
          }
        }
        &:nth-child(2n) {
          margin-right: 0;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// activity.vue?4d578cea